import { render } from "./QuestionDragDrop.vue?vue&type=template&id=149bd8c1"
import script from "./QuestionDragDrop.vue?vue&type=script&lang=js"
export * from "./QuestionDragDrop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__